import React, {Component} from "react";
import styles from './ProjectPanel.css'

class ProjectPanelTooltip extends Component {
  render() {
    if (this.props.visible && this.props.info) {
      return (
        <div className="tooltip">
          {this.props.info ? `运行结果: ${this.props.info}` : "暂无结果"}
        </div>
      )
    } else {
      return null
    }
  }
}

export default ProjectPanelTooltip;
